/*
 *  Product Description
 *    Create accordion for the product description metafield data.
 *
 *  Version:
 *    1.0.0 - 2019/08/05
 */
import { register, ShopifySection } from './../../sections/ShopifySection';
import { Accordion } from './../../objects/accordion/Accordion';

export const CONTAINER_SELECTOR = '[data-terms-wrapper]';
export const ACCORDION_SELECTOR = '[data-accordion]';

export class TermsConditions extends ShopifySection {
  constructor(container) {
    super(container);

    //Accordion (If it exists)
    let accordionElement = container.find(ACCORDION_SELECTOR);

    if(accordionElement && accordionElement.length) {
      this.accordion = new Accordion(accordionElement);
    }
  }
}

register(CONTAINER_SELECTOR, TermsConditions);
